import { createRouter, createWebHistory } from 'vue-router'

// Import views
import DashboardView from '../views/DashboardView.vue'
import ResearchView from '../views/ResearchView.vue'
import ReportsView from '../views/ReportsView.vue'
import MosquitoView from '../views/MosquitoView.vue'
import MothView from '../views/MothView.vue'
import TasksView from '../views/TasksView.vue'
import MapView from '../views/MapView.vue'
import DevicesView from '../views/DevicesView.vue'
import MarketplaceView from '../views/MarketplaceView.vue'
import AccountView from '../views/AccountView.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: {
      title: 'Dashboard - AgriFlight'
    }
  },
  {
    path: '/research',
    name: 'Research',
    component: ResearchView,
    meta: {
      title: 'Research & Insights - AgriFlight'
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: ReportsView,
    meta: {
      title: 'Reports & Analytics - AgriFlight'
    }
  },
  {
    path: '/mosquito',
    name: 'Mosquito',
    component: MosquitoView,
    meta: {
      title: 'Mosquito Control - AgriFlight'
    }
  },
  {
    path: '/moth',
    name: 'Moth',
    component: MothView,
    meta: {
      title: 'Moth Control - AgriFlight'
    }
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: TasksView,
    meta: {
      title: 'Tasks - AgriFlight'
    }
  },
  {
    path: '/map',
    name: 'Map',
    component: MapView,
    meta: {
      title: 'Map - AgriFlight'
    }
  },
  {
    path: '/devices',
    name: 'Devices',
    component: DevicesView,
    meta: {
      title: 'Devices - AgriFlight'
    }
  },
  {
    path: '/marketplace',
    name: 'Marketplace',
    component: MarketplaceView,
    meta: {
      title: 'Marketplace - AgriFlight'
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: AccountView,
    meta: {
      title: 'Account - AgriFlight'
    }
  }
]

export function createAppRouter() {
  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { top: 0 }
      }
    }
  })

  // Router navigation guard for page titles
  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  })

  return router
}
